import React from 'react';
import PropTypes from 'prop-types';
import MiniImage from './MiniImage';

export default class ThumbnailsListView extends React.Component {
    constructor() {
        super();
        this.state = {
            shownNumber: 0,
            visibleNumber: 6,
        };
    }

    componentWillReceiveProps(newProps) {
        // check if the page changed and scroll to selected thumb
        let list = this.list;
        if (newProps.selectedPage !== this.props.selectedPage && list) {
            if (list.children) {
                let childNode = list.children[newProps.selectedPage - 1];
                let positionShould = newProps.selectedPage * newProps.imageHeight;
                let currentBottomEdge = list.clientHeight + list.scrollTop;
                if (positionShould > currentBottomEdge) {
                    childNode.scrollIntoView(false);
                } else {
                    if (list.scrollTop > positionShould - newProps.imageHeight) {
                        childNode.scrollIntoView(true);
                    }
                }
            }
        }
    }

    /**
     *  onclick image frame
     * @param page
     */
    onFrameClick = page => {
        if (this.props.onSelect) this.props.onSelect(page);
    };

    /**
     * helper to check if this page visible in scroll view
     * @param page
     * @returns {boolean}
     */
    isVisible = page => {
        return this.state.visibleNumber + this.state.shownNumber >= page;
    };

    /**
     * listening for scroll to change the count of the visible frames
     * @param e
     */
    onScroll = e => {
        let scrollTop = e.target.scrollTop;
        let shownNumber = Math.round(scrollTop / this.props.imageHeight);
        if (shownNumber !== this.state.shownNumber) {
            this.setState({ shownNumber: shownNumber });
        }
    };

    isThereNotesOnPage = page => {
        if (!this.props.annotations || this.props.annotations.length < 1) return false;
        return this.props.annotations.some(item => item.page === page);
    };

    /**
     * render list of frames
     * @param totalPages
     * @param selectedPage
     * @returns {Array}
     */
    renderList = (totalPages, selectedPage) => {
        let list = [];
        for (let i = 1; i <= totalPages; i++) {
            let styles = {
                height: this.props.imageHeight,
            };
            list.push(
                <li
                    className={'thumbs-panel-list-item' + (selectedPage === i ? ' selected' : '')}
                    onClick={this.onFrameClick.bind(this, i)}
                    key={i}
                    style={styles}
                >
                    <MiniImage
                        selected={selectedPage === i}
                        visible={this.isVisible(i)}
                        page={i}
                        blob={this.props.blob}
                        isThereNotesOnPage={this.isThereNotesOnPage(i)}
                        notesIcon={this.props.notesIcon}
                        imageHeight={this.props.imageHeight}
                    />
                </li>,
            );
        }
        return list;
    };

    render() {
        let { blob, totalPages, selectedPage } = this.props;
        // console.log('ThumbnailsListView render', blob);

        return (
            <div id="thumbs-wrapper" className={this.props.show ? '' : 'hidden'}>
                <label className="thumbs-panel-toggler" onClick={this.props.toggle}>
                    {this.props.toggleIcon}
                </label>
                {!blob || !totalPages ? (
                    <div className="loader-wrapper">
                        <div className="loader loader--style10" title="Loading PDF">
                            <div className="spinner-10">
                                <div className="double-bounce1" />
                                <div className="double-bounce2" />
                            </div>
                        </div>
                    </div>
                ) : (
                    <ul
                        ref={el => (this.list = el)}
                        className="thumbs-panel-list"
                        onScroll={this.onScroll}
                    >
                        {this.renderList(totalPages, selectedPage)}
                    </ul>
                )}
            </div>
        );
    }
}

ThumbnailsListView.propTypes = {
    toggleIcon: PropTypes.any,
    blob: PropTypes.string,
    onSelect: PropTypes.func,
    selectedPage: PropTypes.number,
    totalPages: PropTypes.number,
    imageHeight: PropTypes.number,
    notesIcon: PropTypes.any,
    annotations: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool,
    toggle: PropTypes.func,
};

ThumbnailsListView.defaultProps = {
    imageHeight: 212,
    onSelect: null,
    annotations: null,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/ThumbnailsListView.js